import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { omit } from '@/shared/utils/omit';

import {
  DriversLicenseCategoriesList,
  DriversLicenseCategory,
  PersonalIdentifierDetails,
} from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type DriverLicenseGeneralFormType = PersonalIdentifierGeneralFormType;

export const DriverLicenseGeneralSection: DriverLicenseGeneralFormType = {
  ...commonGeneralFields,
};

export type DriverLicenseDetailsDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'> & {
  category?: string;
  otherCategory?: string;
  restrictions?: string;
};

type DriverLicenseDetailsHelp = {
  category: QuestionType.SELECT_FROM_LIST;
  otherCategory: QuestionType.TEXT;
  restrictions: QuestionType.TEXT;
};

export type DriverLicenseDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'basisForIssuingId' | 'placeOfBirth'
> &
  TDtoWrapper<DriverLicenseDetailsDto, DriverLicenseDetailsHelp>;

export const DriverLicenseDetailsSection: DriverLicenseDetailsFormType = {
  category: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_personal_ids:driverLicense.inputs.category.label',
    items: DriversLicenseCategoriesList,
    order: 6,
  },
  otherCategory: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:driverLicense.inputs.otherCategory.label',
    value: '',
    order: 6,
    disableIf: {
      category: {
        value: DriversLicenseCategory.other,
      },
    },
  },
  restrictions: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:driverLicense.inputs.restrictions.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  ...omit(commonDetailsFields, 'basisForIssuingId', 'placeOfBirth'),
};

export const DriverLicenseLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const DriverLicenseFormSections = [
  DriverLicenseGeneralSection,
  DriverLicenseDetailsSection,
  DriverLicenseLegalizedCopiesSection,
];
